import {observable, action, computed} from 'mobx'
import {notification} from 'antd'
import {defaultData, defaultStatus} from './consts/defaults'

export class IbStore {
  @observable data = {...defaultData}
  @observable status = {...defaultStatus}
  @observable modal = false

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  @computed get isUserPremium() {
    const {account} = this.rootStore.user.data
    return account?.billing_plan?.id >= 3
  }

  @action async getCredentials() {
    try {
      const data = await this.api.request('sys/ib/credentials', 'get')
      this.data = {...this.data, ...data}
      this.exists = true
      if (!this.data.is_checked) {
        setTimeout(() => this.getCredentials(), 3000)
      } else {
        this.root.permissions.loadList()
      }
    } catch (e) {
      this.setStatus('exists', false)
      if (e.status_code === 404) {
        return
      }
      notification['error']({
        message: 'Failed to get IB credentials',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.setStatus('loaded', true)
    }
  }

  @action async setCredentials() {
    this.setStatus('exists', true)
    this.change('is_checked', false)
    const {username, password, trading_mode} = this.data
    const body = {username, password, trading_mode}
    try {
      const data = await this.api.request('sys/ib/credentials', 'put', body)
      this.data = {...this.data, ...data}
      if (!this.data.is_checked) {
        setTimeout(() => this.getCredentials(), 3000)
      }
    } catch (e) {
      notification['error']({
        message: 'Failed to set IB credentials',
        description: e.message || 'Unknown error'
      })
    }
  }

  @action async disable(confirm = false) {
    this.setStatus('disabling', true)
    try {
      if (confirm) {
        const body = {
          pause_active_live_sessions: true
        }
        await this.api.request('sys/ib/credentials/disable', 'post', body)
      } else {
        await this.api.request('sys/ib/credentials/disable', 'post')
      }
      this.change('is_connected', false)
      this.change('is_checked', true)
      this.setStatus('liveModal', false)
      this.root.permissions.loadList()
    } catch (e) {
      if (e.code === 4261) {
        this.setStatus('liveModal', true)
        return
      }
      notification['error']({
        message: 'Failed to disconnect IB',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.setStatus('disabling', false)
    }
  }

  @action change(key, value) {
    this.data[key] = value
  }

  @action setStatus(key, value) {
    this.status[key] = value
  }

  @action openModal = () => {
    this.modal = true
  }

  @action closeModal = () => {
    this.modal = false
  }
}
